import { useEffect, useState } from "react";
import usePost from "../../hooks/usePost";
import { FABRIC } from "../../routes/routes_name";
import { useLocation } from "react-router-dom";
import usePut from "../../hooks/usePut";
import { propTypes } from "react-bootstrap/esm/Image";
import useGenerateQr from "../../hooks/useGenerateQr";
import { data } from "autoprefixer";

const UseFormFabric = (props) => {
  const { isLoading, error, isSuccess, navigate, handlePost } = usePost();
  const {
    handleSave,
    handleGenerate,
    getTemplate,
    dataTemplate,
    isSuccessTemplate,
  } = useGenerateQr();
  const {
    isLoading: isLoadingPut,
    error: errorPut,
    isSuccess: isSuccessPut,
    navigate: navigatePut,
    handlePut,
  } = usePut();

  const location = useLocation();

  const [form, setForm] = useState({});
  const [isOn, setIsOn] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const formData = new FormData();
  useEffect(() => {}, [isLoading]);

  useEffect(() => {
    getTemplate();

    if (props.type === "qr") {
      setIsOn(dataTemplate.showBox);
      let id = [];
      location.state.map((val) => {
        id.push(val._id);
      });
      setForm({
        ...form,
        id: id,
        paperWidth: dataTemplate.paperWidth,
        paperHeight: dataTemplate.paperHeight,
        boxWidth: dataTemplate.boxWidth,
        boxHeight: dataTemplate.boxHeight,
        qrSize: dataTemplate.qrSize,
        fontSize: dataTemplate.fontSize,
        marginTop: dataTemplate.marginTop,
        marginBottom: dataTemplate.marginBottom,
        marginLeft: dataTemplate.marginLeft,
        marginRight: dataTemplate.marginRight,
        gapX: dataTemplate.gapX,
        gapY: dataTemplate.gapY,
        labelGapY: dataTemplate.labelGapY,
        gapQrLogo: dataTemplate.gapQrLogo,
        qrMarginTop: dataTemplate.qrMarginTop,
        qrMarginBottom: dataTemplate.qrMarginBottom,
        qrMarginLeft: dataTemplate.qrMarginLeft,
        logoMarginTop: dataTemplate.logoMarginTop,
        logoMarginBottom: dataTemplate.logoMarginBottom,
        showBox: dataTemplate.showBox,
        logoSize: dataTemplate.logoSize,
        logoUrl: dataTemplate.logoUrl,
      });
    }
  }, [isSuccessTemplate]);

  useEffect(() => {
    if (props.type === "post") {
      setForm({
        ...form,
        fabric_name: "",
        brand: "",
        stock_code: "",
        pattern: "",
        color: "",
        material: "",
        // type: "",
        image: null,
        status: "in aktif",
      });
    } else {
      handleSwitch(location.state.status);
      setIsOn(location.state.status === "aktif");
      setForm({
        ...form,
        id: location.state._id,
        fabric_name: location.state.fabric_name,
        brand: location.state.brand,
        stock_code: location.state.stock_code,
        pattern: location.state.pattern,
        color: location.state.color,
        material: location.state.material,
        // type: location.state.type.toLowerCase(),
        image: location.state.image,
        status: location.state.status,
        product: location.state.product,
        price: location.state.price,
        description: location.state.description,
      });
    }
  }, []);

  const handleSwitch = (props) => {
    if (props !== "") {
      setForm({
        ...form,
        ["status"]: props,
      });
      setIsOn(props === "aktif");
    } else {
      setForm({
        ...form,
        ["status"]: !isOn ? "aktif" : "in aktif",
      });
      setIsOn(!isOn);
    }
  };

  const handleSwitchBox = (props) => {
    if (props !== "") {
      setForm({
        ...form,
        ["showBox"]: props,
      });
      setIsOn(false);
    } else {
      setForm({
        ...form,
        ["showBox"]: !isOn ? true : false,
      });
      setIsOn(!isOn);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    formData.append("fabric_name", form["fabric_name"]);
    formData.append("brand", form["brand"]);
    formData.append("stock_code", form["stock_code"]);
    formData.append("pattern", form["pattern"]);
    formData.append("color", form["color"]);
    // formData.append("type", form["type"].toLowerCase());
    formData.append("material", form["material"]);
    if (selectedImage) {
      formData.append("fabric_image", selectedImage);
    }
    formData.append("status", form["status"] ?? "in aktif");
    formData.append("productId", form["product"] ?? "");
    formData.append("price", form["price"]);
    formData.append("description", form["description"]);
    let params = {
      url: "/v1/fabric",
      form: formData,
      navigation: FABRIC,
      titleSuccess: "Saved!",
      descSuccess: "Fabric data has been successfully saved.",
      type: "multipart/form-data",
    };

    if (props.type === "post") {
      handlePost(params);
    } else {
      params.titleSuccess = "Edited!";
      params.descSuccess = "Fabric data has been successfully edited.";
      params.url = `/v1/fabric?_id=${form["id"]}`;
      handlePut(params);
    }
  };

  const handleImageChange = (img) => {
    setSelectedImage(img);
    const newSetForm = { ...form };
    const reader = new FileReader();
    reader.onloadend = () => {
      newSetForm.image = reader.result;
      setForm(newSetForm);
    };
  };

  const handleChange = (props) => {
    const { id, value } = props.target;

    setForm({
      ...form,
      [id]: value,
    });
  };
  const handleGenerateQr = (e) => {
    e.preventDefault();
    let params = form;

    handleGenerate(params);
  };

  const handleSaveQr = (e) => {
    e.preventDefault();
    let params = form;

    handleSave(params);
  };
  const removePreview = () => {
    const newSetForm = { ...form };
    newSetForm.image = null;
    setForm(newSetForm);
  };

  return {
    isLoading,
    isLoadingPut,
    form,
    formData,
    isOn,
    removePreview,
    handleSwitch,
    handleSwitchBox,
    handleChange,
    handleImageChange,
    handleSubmit,
    handleGenerateQr,
    handleSaveQr,
  };
};

export default UseFormFabric;
